import Component from '@glimmer/component';

export default class SiteAuditHealthComponent extends Component {
  get safePoints() {
    return this.args.maxPoints > 0 ? this.args.points : 0;
  }
}
